import React from "react";
import Grid from "@material-ui/core/Grid";
import "../../../assets/css/home.css";
import i18n from "i18next";

const HomePage = () => {
    const renderHomePage = () => {
        return (
            <div className="slider_area">
                <div className="slider_bg">
                    <Grid container justify="center" alignItems="center">
                        <Grid item xs={12} sm={6}>
                            <div className="illastrator_png">
                                <img src={require("./../../../assets/images/banner/edu_ilastration1.png")} alt="Test"/>
                            </div>
                        </Grid>
                        <Grid item xs={12} sm={6}>
                            <div className="slider-info">
                                <h3>
                                    {i18n.t('learn_everywhere')}
                                </h3>
                            </div>
                        </Grid>
                    </Grid>
                </div>
            </div>
        );
    };

    return renderHomePage();
};

export default HomePage;